/**
 * Global config variables
 */
export const PAGE_LOAD_TIMEOUT = 1000;
